function formatDateToSqlDateTime() {
	/*
		this code was taken from:
		https://stackoverflow.com/questions/5129624/convert-js-date-time-to-mysql-datetime
	*/

	// Your default date object
	var starttime = new Date();
	// Get the iso time (GMT 0 == UTC 0)
	var isotime = new Date((new Date(starttime)).toISOString());
	// getTime() is the unix time value, in milliseconds.
	// getTimezoneOffset() is UTC time and local time in minutes.
	// 60000 = 60*1000 converts getTimezoneOffset() from minutes to milliseconds.
	var fixedtime = new Date(isotime.getTime()-(starttime.getTimezoneOffset()*60000));
	// toISOString() is always 24 characters long: YYYY-MM-DDTHH:mm:ss.sssZ.
	// .slice(0, 19) removes the last 5 chars, ".sssZ",which is (UTC offset).
	// .replace('T', ' ') removes the pad between the date and time.
	return fixedtime.toISOString().slice(0, 19).replace('T', ' ');
}

export { formatDateToSqlDateTime };